/* istanbul ignore file */
export { fn_a1f9a } from './fn_a1f9a';
